/**
 * Badge styling for a benchmark trade's direction.
 *
 * The ba_*_trades tables hold ONE row per (fund, trade_date) shared across the five portfolios.
 * A fund can therefore be bought in one portfolio and sold in another on the same day, which the
 * hypothetical calculator records as MIXED. MARKER rows are position stamps rather than trades.
 *
 * All four trade logs previously hard-coded `direction === "BUY" ? "default" : "destructive"`,
 * which painted MIXED and MARKER red and read as a sell.
 */
export type TradeDirection = "BUY" | "SELL" | "MARKER" | "MIXED";

export function tradeDirectionVariant(
  direction: string | null | undefined,
): "default" | "destructive" | "secondary" {
  switch (direction) {
    case "BUY":
      return "default";
    case "SELL":
      return "destructive";
    default:
      // MIXED and MARKER are neither a buy nor a sell, and an unrecognised value should not
      // silently borrow the styling of one.
      return "secondary";
  }
}

/** Longer explanation for a tooltip or title attribute. */
export function tradeDirectionHint(direction: string | null | undefined): string | undefined {
  switch (direction) {
    case "MIXED":
      return "Bought in one portfolio and sold in another on this date";
    case "MARKER":
      return "Position marker rather than a trade";
    default:
      return undefined;
  }
}
